import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';

export default function CapitalInvestmentServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Capital Services</title>
        <meta
          name='description'
          content='We don’t just build properties—we structure partnerships, secure funding, and unlock financial potential.'
        />
        <meta
          name='keywords'
          content='Capital Services, Real Estate Development, Pre-Development Planning, Design-Build, Smart & Sustainable Building'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Capital Services | Fueling ambitious projects with strategic funding
        </h2>
        <p className='service-page-text'>
          We connect our developments with a range of capital sources including
          private equity and EB5 investment. Each opportunity is structured for
          both investor value and project viability.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            // to={ROUTE_NAMES.CAPITALVENTURES}
            className='service-block'
          >
            <h3>Domestic capital partnerships and private equity</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          {/* <Link to={ROUTE_NAMES.LENDINGSOLUTIONS} className='service-block'>
            <h3>Lending Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link> */}
          <Link
            to={ROUTE_NAMES.EBSERVICE}
            className='service-block green-block'
          >
            <h3>EB5 investment program for foreign investors</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
